import React from "react";

const NotifModal = (props) => {
    return (
        <div
            onScroll={(e) => {
                e.stopPropagation();
            }}
            className="wallet-main gift"
        >
            <div className="wallet-modal description h-400">
                <h2>{props.item.title}</h2>
                <div className="p-box">
                    <p>{props.item.Content}</p>
                </div>
                {props.showMarkRead ? (
                    <button type="button" className="notif-read-btn" onClick={props.onMarkRead}>
                        خوانده شد
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default NotifModal;
